import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { startCase } from 'lodash';
import { processValidate, renderField } from 'infrastructure/form';

const TextField = props => {
  const {
    id,
    name,
    label,
    type,
    validate,
    publishRequiredOnly,
    ...fieldProps
  } = props;

  return (
    <Field
      {...fieldProps}
      component={renderField}
      id={id || name}
      name={name}
      type={type}
      validate={processValidate(label || startCase(name), validate, {
        ...fieldProps,
        publishRequiredOnly,
      })}
    />
  );
};

TextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  validate: PropTypes.arrayOf(PropTypes.shape({})),
  publishRequiredOnly: PropTypes.bool,
};

TextField.defaultProps = {
  label: '',
  name: '',
  type: 'text',
  validate: [],
  publishRequiredOnly: false,
};

export default TextField;
